import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
// 4
import EmojiEmotionsTwoToneIcon from "@material-ui/icons/EmojiEmotionsTwoTone";
//2
import MoodBadTwoToneIcon from "@material-ui/icons/MoodBadTwoTone";
import RadioButtonUncheckedTwoToneIcon from "@material-ui/icons/RadioButtonUncheckedTwoTone";
//1
import SentimentVeryDissatisfiedTwoToneIcon from "@material-ui/icons/SentimentVeryDissatisfiedTwoTone";
//5
import SentimentVerySatisfiedTwoToneIcon from "@material-ui/icons/SentimentVerySatisfiedTwoTone";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import { theme as themeConfig } from "../../themes/themes";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import { ReactComponent as TwotoneSentimentNeutral } from "../../themes/Icons/TwotoneSentimentNeutral.svg";
import MessageYesNo from "../MessageYesNo/index";
import ModalSaveToBank from "../ModalSaveToBank";
import {
  CloneButton,
  ContainerButtons,
  ContainerSelectOptions,
  ContainerTitle,
  DeleteButton,
  EditButton,
  EditSection,
  GeneralStyle,
  HorizontalLines,
  LowerWrapper,
  MediumWrapper,
  NeutralFace,
  QuestionWrapper,
  SaveToBank,
  SelectsSection,
  SizeFace,
  ThirdOptions,
  UpperWrapper,
  VSection,
  TooltipCheckSection,
  TooltipDescriptionContainer,
} from "./SmileyFacesBox.styled";
import InfoIcon from "@material-ui/icons/Info";

const SmileyFacesBox = ({
  error,
  loading,
  data,
  textTitle,
  setTextTitle,
  selectCategory,
  setSelectCategory,
  checkMandatory,
  setCheckMandatory,
  textValidation,
  setTextValidation,
  selectQuantity,
  setSelectQuantity,
  editable,
  questionSettings,
  setQuestionSettings,
  saveQuestionBank,
  handleEdit,
  handleCancel,
  configQuestionStyle,
  setconfigQuestionStyle,
  blockKey,
  handleDeleteQuestion,
  idQuestionSurvey,
  globalProps,
  categories,
  identity,
  tooltipInformationCheck,
  tooltipDescriptionText,
  setShowTooltipDescription,
  handleTextAreaText,
  changeTooltipInformationCheck,
  showTooltipDescription,
}) => {
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [colorBackground] = useState("#f9f9f9");
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);

  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };

  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion(blockKey);
    }
  }, [responseMessageYesNo]);

  let handleTitleInput = (e) => {
    setTextTitle(e.target.value);
  };

  let handleCaregoryInput = (e) => {
    setSelectCategory(e.target.value);
  };

  let handleMandatory = (e) => {
    setCheckMandatory(e.target.checked);
  };

  let handleColorPicker = (id, event) => {
    handleChangeInput(id, event);
  };

  let handleValidationInput = (e) => {
    setTextValidation(e.target.value);
  };

  let loadCategories = () => {
    if (loading) return <option key="0">Loading...</option>;
    if (error) return <option key="0">Error :(</option>;
    if (!loading && !error)
      return data.map(({ recordState, description, idCategoryQuestion }) => {
        if (recordState.toUpperCase() == "ACTIVE") {
          return (
            <option key={idCategoryQuestion} value={idCategoryQuestion}>
              {description}
            </option>
          );
        }
        return null;
      });
  };

  const handleChangeInput = (id, event) => {
    const newQuestionSettingsTwo = questionSettings.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });

    setQuestionSettings(newQuestionSettingsTwo);
  };

  let handleClickFaceFive = (id) => {
    const newQuestionSettings = questionSettings.map((i) => {
      if (id === i.id) {
        i["face"] = 5;
        i["value"] = "5";
      }
      return i;
    });
    if (checkDuplicateSmileySelect(newQuestionSettings, 5)) {
      setQuestionSettings(newQuestionSettings);
    } else {
      NotificationManager.warning("Please choose a different smiley", "", 5000);
    }
  };

  let handleClickFaceFour = (id) => {
    const newQuestionSettings = questionSettings.map((i) => {
      if (id === i.id) {
        i["face"] = 4;
        i["value"] = "4";
      }
      return i;
    });
    if (checkDuplicateSmileySelect(newQuestionSettings, 4)) {
      setQuestionSettings(newQuestionSettings);
    } else {
      NotificationManager.warning("Please choose a different smiley", "", 5000);
    }
  };

  let handleClickFacethree = (id) => {
    const newQuestionSettings = questionSettings.map((i) => {
      if (id === i.id) {
        i["face"] = 3;
        i["value"] = "3";
      }
      return i;
    });
    if (checkDuplicateSmileySelect(newQuestionSettings, 3)) {
      setQuestionSettings(newQuestionSettings);
    } else {
      NotificationManager.warning("Please choose a different smiley", "", 5000);
    }
  };
  let handleClickFaceTwo = (id) => {
    const newQuestionSettings = questionSettings.map((i) => {
      if (id === i.id) {
        i["face"] = 2;
        i["value"] = "2";
      }
      return i;
    });
    if (checkDuplicateSmileySelect(newQuestionSettings, 2)) {
      setQuestionSettings(newQuestionSettings);
    } else {
      NotificationManager.warning("Please choose a different smiley", "", 5000);
    }
  };

  let handleClickFaceOne = (id) => {
    const newQuestionSettings = questionSettings.map((i) => {
      if (id === i.id) {
        i["face"] = 1;
        i["value"] = "1";
      }
      return i;
    });
    if (checkDuplicateSmileySelect(newQuestionSettings, 1)) {
      setQuestionSettings(newQuestionSettings);
    } else {
      NotificationManager.warning("Please choose a different smiley", "", 5000);
    }
  };

  const checkDuplicateSmileySelect = (questionSettings, faceId) => {
    let filterArr = questionSettings.filter((i) => i.face == faceId);
    return filterArr.length <= 1;
  };

  let handSectionSubpanel = (e) => {
    setSelectQuantity(e.target.value);

    switch (parseInt(e.target.value)) {
      case 2:
        const newQuestionSettingsTwo = questionSettings.filter(
          (item) => item.id <= 2
        );
        setQuestionSettings(newQuestionSettingsTwo);
        break;
      case 3:
        if (questionSettings.length > 3) {
          const newQuestionSettingsThree = questionSettings.filter(
            (item) => item.id <= 3
          );
          setQuestionSettings(newQuestionSettingsThree);
        } else {
          setQuestionSettings([
            ...questionSettings,
            { id: 3, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        }
        break;
      case 4:
        if (questionSettings.length > 4) {
          const newQuestionSettingsFour = questionSettings.filter(
            (item) => item.id <= 4
          );
          setQuestionSettings(newQuestionSettingsFour);
        } else if (questionSettings.length === 2) {
          setQuestionSettings([
            ...questionSettings,
            { id: 3, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
            { id: 4, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        } else if (questionSettings.length === 3) {
          setQuestionSettings([
            ...questionSettings,
            { id: 4, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        }

        break;
      case 5:
        if (questionSettings.length === 2) {
          setQuestionSettings([
            ...questionSettings,
            { id: 3, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
            { id: 4, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
            { id: 5, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        } else if (questionSettings.length === 3) {
          setQuestionSettings([
            ...questionSettings,
            { id: 4, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
            { id: 5, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        } else if (questionSettings.length === 4) {
          setQuestionSettings([
            ...questionSettings,
            { id: 5, lbtext: "", value: "1", face: "", color: themeConfig.neutral.black },
          ]);
        }

        break;
      default:
        const newQuestionSettingsDEfault = questionSettings.filter(
          (item) => item.id <= 2
        );
        setQuestionSettings(newQuestionSettingsDEfault);

        break;
    }
  };

  let loadQuestionSettings = () => {
    return questionSettings.map((QuestionSetting) => (
      <div className="row MargenDiv" key={QuestionSetting.id}>
        <div className="col-2 CustomLabel">
          <label>Face {QuestionSetting.id}</label>
        </div>
        <div className="col-4 CustomInput">
          <input
            type="text"
            name="lbtext"
            placeholder="Add description"
            onChange={(event) => handleChangeInput(QuestionSetting.id, event)}
            defaultValue={QuestionSetting.lbtext}
            className="input-questions"
          />
        </div>
        {/* <input name="value" className="InputNumber" onChange={event => handleChangeInput(QuestionSetting.id, event)} type="number" min="1" max="5" placeholder="" /> */}
        {/* <div className="col-2 CustomInput-value">
          <select
            name="value"
            defaultValue={QuestionSetting.value}
            onChange={(event) => handleChangeInput(QuestionSetting.id, event)}
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
          </select>
        </div> */}

        <div className="col-2 ml-5 mr-2 CustomInput">
          <Dropdown>
            <Dropdown.Toggle className="DropdownFace">
              {QuestionSetting.face === 1 ? (
                <SentimentVerySatisfiedTwoToneIcon
                  className="HeightFace"
                  style={{ fill: QuestionSetting.color }}
                />
              ) : null}
              {QuestionSetting.face === 2 ? (
                <EmojiEmotionsTwoToneIcon
                  className="HeightFace"
                  style={{ fill: QuestionSetting.color }}
                />
              ) : null}
              {QuestionSetting.face === 3 ? (
                <NeutralFace colorBackground={QuestionSetting.color}>
                  <TwotoneSentimentNeutral
                    className="HeightFace"
                    style={{ fill: QuestionSetting.color }}
                  />
                </NeutralFace>
              ) : null}
              {QuestionSetting.face === 4 ? (
                <MoodBadTwoToneIcon
                  className="HeightFace"
                  style={{ fill: QuestionSetting.color }}
                />
              ) : null}
              {QuestionSetting.face === 5 ? (
                <SentimentVeryDissatisfiedTwoToneIcon
                  className="HeightFace"
                  style={{ fill: QuestionSetting.color }}
                />
              ) : null}
              {QuestionSetting.face === "" ? (
                <RadioButtonUncheckedTwoToneIcon
                  className="HeightFace"
                  style={{ fill: QuestionSetting.color }}
                />
              ) : null}
            </Dropdown.Toggle>

            <Dropdown.Menu className="modify-dropdown-menu text-center">
              <Dropdown.Item
                onClick={() => handleClickFaceOne(QuestionSetting.id)}
              >
                <SentimentVerySatisfiedTwoToneIcon
                  style={{ fill: QuestionSetting.color, width: "80%" }}
                />
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleClickFaceTwo(QuestionSetting.id)}
              >
                <EmojiEmotionsTwoToneIcon
                  style={{ fill: QuestionSetting.color, width: "80%" }}
                />
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleClickFacethree(QuestionSetting.id)}
              >
                <NeutralFace colorBackground={QuestionSetting.color}>
                  <TwotoneSentimentNeutral
                    style={{ fill: QuestionSetting.color, width: "80%" }}
                  />
                </NeutralFace>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleClickFaceFour(QuestionSetting.id)}
              >
                <MoodBadTwoToneIcon
                  style={{ fill: QuestionSetting.color, width: "80%" }}
                />
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => handleClickFaceFive(QuestionSetting.id)}
              >
                <SentimentVeryDissatisfiedTwoToneIcon
                  style={{ fill: QuestionSetting.color, width: "80%" }}
                />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-2 CustomInput">
          <input
            type="color"
            name="color"
            className="ColorPicker"
            defaultValue={QuestionSetting.color}
            onChange={(event) => handleColorPicker(QuestionSetting.id, event)}
          />
        </div>
      </div>
    ));
  };

  let loadPreviewQuestions = () => {
    return questionSettings.map((QuestionSetting) => {
      switch (parseInt(QuestionSetting.face)) {
        case 5:
          return (
            <SizeFace key={QuestionSetting.id}>
              <h3
                style={
                  configQuestionStyle.customStyle
                    ? configQuestionStyle.answer
                    : stateQuestionsReducer.globalStyle.answers
                }
              >
                {" "}
                {QuestionSetting.lbtext}{" "}
              </h3>
              <SentimentVeryDissatisfiedTwoToneIcon
                style={{ fill: QuestionSetting.color }}
              />
            </SizeFace>
          );

        case 4:
          return (
            <SizeFace key={QuestionSetting.id}>
              <h3
                style={
                  configQuestionStyle.customStyle
                    ? configQuestionStyle.answer
                    : stateQuestionsReducer.globalStyle.answers
                }
              >
                {" "}
                {QuestionSetting.lbtext}{" "}
              </h3>
              <MoodBadTwoToneIcon style={{ fill: QuestionSetting.color }} />
            </SizeFace>
          );

        case 3:
          return (
            <SizeFace key={QuestionSetting.id}>
              <h3
                style={
                  configQuestionStyle.customStyle
                    ? configQuestionStyle.answer
                    : stateQuestionsReducer.globalStyle.answers
                }
              >
                {" "}
                {QuestionSetting.lbtext}{" "}
              </h3>
              <NeutralFace colorBackground={QuestionSetting.color}>
                <TwotoneSentimentNeutral
                  style={{ fill: QuestionSetting.color }}
                />
              </NeutralFace>
            </SizeFace>
          );

        case 2:
          return (
            <SizeFace key={QuestionSetting.id}>
              <h3
                style={
                  configQuestionStyle.customStyle
                    ? configQuestionStyle.answer
                    : stateQuestionsReducer.globalStyle.answers
                }
              >
                {" "}
                {QuestionSetting.lbtext}{" "}
              </h3>
              <EmojiEmotionsTwoToneIcon
                style={{ fill: QuestionSetting.color }}
              />
            </SizeFace>
          );

        case 1:
          return (
            <SizeFace key={QuestionSetting.id}>
              <h3
                style={
                  configQuestionStyle.customStyle
                    ? configQuestionStyle.answer
                    : stateQuestionsReducer.globalStyle.answers
                }
              >
                {" "}
                {QuestionSetting.lbtext}{" "}
              </h3>
              <SentimentVerySatisfiedTwoToneIcon
                style={{ fill: QuestionSetting.color }}
              />
            </SizeFace>
          );

        default:
          return null;
      }
    });
  };

  return (
    <GeneralStyle
      isDependent={globalProps.GisDependent}
      editable={editable}
      colorBackground={
        configQuestionStyle.customStyle
          ? configQuestionStyle.background
          : colorBackground
      }
    >
      {editable ? (
        <EditSection>
          <VSection>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkMandatory}
                  onChange={(e) => handleMandatory(e)}
                  name="mandatory-check"
                />
              }
              label="Mandatory Question"
            />
            {checkMandatory ? (
              <input
                onChange={(e) => handleValidationInput(e)}
                type="text"
                placeholder="Enter mandatory message here"
                id="mText"
                defaultValue={textValidation}
              ></input>
            ) : null}
          </VSection>
          <hr />
          <UpperWrapper>
            <QuestionWrapper>
              <label>Question:</label>
              <textarea
                onChange={(e) => handleTitleInput(e)}
                type="text"
                placeholder="Enter your question here"
                defaultValue={textTitle}
              ></textarea>
            </QuestionWrapper>
            {identity !== "form" && (
              <>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <SelectsSection>
                      <div>
                        <label>Category</label>
                        <select
                          onChange={(e) => handleCaregoryInput(e)}
                          defaultValue={selectCategory}
                        >
                          <option value={0}>- Category -</option>
                          {loadCategories()}
                        </select>
                      </div>
                    </SelectsSection>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "35px",
                      paddingTop: "20px",
                    }}
                  >
                    <TooltipCheckSection>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={tooltipInformationCheck}
                            onChange={(e) => {
                              changeTooltipInformationCheck(e.target.checked);
                            }}
                            name="tooltip-info-check"
                          />
                        }
                        label="Add information tooltip to question"
                      />
                    </TooltipCheckSection>
                  </Grid>
                </Grid>
                {tooltipInformationCheck && (
                  <Grid
                    container
                    style={{ display: "flex", alignContent: "flex-end" }}
                  >
                    <Grid item xs={12} sm={3}>
                      <></>
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TooltipDescriptionContainer>
                        <textarea
                          style={{ height: "80px", resize: "none" }}
                          onChange={(e) => handleTextAreaText(e.target.value)}
                          type="text"
                          placeholder="Type text here..."
                          id="tooltipDescription"
                          defaultValue={tooltipDescriptionText}
                        ></textarea>
                      </TooltipDescriptionContainer>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </UpperWrapper>
        </EditSection>
      ) : null}
      <ContainerSelectOptions>
        {editable ? (
          <MediumWrapper>
            <ThirdOptions>Selection quantity</ThirdOptions>
            <select
              defaultValue={selectQuantity}
              onChange={(e) => handSectionSubpanel(e)}
            >
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
            </select>

            <HorizontalLines>
              <hr></hr>
            </HorizontalLines>
          </MediumWrapper>
        ) : null}

        {editable ? (
          <LowerWrapper>
            <div className="row">
              <div className="col-2 CustomLabel">
                <label></label>
              </div>
              <div className="col-4 CustomInput">
                <label></label>
              </div>
              {/*               <div className="col-2 CustomInput-value">
                <label>Value</label>
              </div> */}
              <div className="col-2 ml-5 mr-2 CustomInput">
                <label>Image</label>
              </div>
              <div className="col-2 CustomInput">
                <label>Color</label>
              </div>
            </div>

            {loadQuestionSettings()}
          </LowerWrapper>
        ) : null}
        <div className="MargenDiv">
          <ContainerTitle
            style={
              configQuestionStyle.customStyle
                ? configQuestionStyle.question
                : stateQuestionsReducer.globalStyle.questions
            }
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              {textTitle}
              {tooltipInformationCheck && tooltipDescriptionText !== "" && (
                <Tooltip
                  placement="left"
                  open={showTooltipDescription}
                  title={
                    <>
                      <Box
                        style={{
                          margin: "0",
                          listStyleType: "circle",
                          lineHeight: "1.3",
                          fontSize: "13px",
                        }}
                      >
                        <span>{tooltipDescriptionText}</span>
                      </Box>
                    </>
                  }
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      setShowTooltipDescription(!showTooltipDescription);
                    }}
                  >
                    <InfoIcon
                      fontSize="small"
                      style={{
                        cursor: "pointer",
                        color: themeConfig.text.primary,
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </ContainerTitle>
          <div className="DivPadre">{loadPreviewQuestions()}</div>
        </div>
      </ContainerSelectOptions>
      {!editable && idQuestionSurvey && !globalProps.questionBank && (
        <div className="overlay-option">
          <div className="bottom-buttons">
            <CloneButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => saveQuestionBank(true)}
            >
              <CloneIcon />
              Clone
            </CloneButton>
            {identity !== "form" && (
              <SaveToBank
                hidden={globalProps.disableButton}
                className="w-25 mt-2 mb-3"
                onClick={() => handleSaveToBank()}
              >
                Save to bank
              </SaveToBank>
            )}
            <DeleteButton
              hidden={globalProps.disableButton}
              className="mx-3 w-25 mt-2 mb-3"
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              Delete
            </DeleteButton>
            <EditButton
              hidden={globalProps.disableButton}
              className="w-25 mt-2 mb-3"
              onClick={() => handleEdit()}
            >
              Edit
            </EditButton>
          </div>
        </div>
      )}
      {editable && (
        <ContainerButtons>
          <div className="left-container">
            <StyledButtonGenericQuestion
              onClick={() => {
                setshowStyleEdit(true);
              }}
            >
              <StyleQuestion />
              Style
            </StyledButtonGenericQuestion>
            {editable && idQuestionSurvey ? (
              <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                <CancelQuestion />
                Cancel
              </StyledButtonGenericQuestion>
            ) : null}
            <StyledButtonGenericQuestion
              lastElement={true}
              onClick={() => setOpenMessageYesNoModal(true)}
            >
              <DeleteQuestion />
              Delete
            </StyledButtonGenericQuestion>
          </div>
          <div className="right-container">
            {editable && (
              <StyledButton
                onClick={() => {
                  saveQuestionBank(false);
                }}
              >
                Save
              </StyledButton>
            )}
          </div>
        </ContainerButtons>
      )}
      {showStyleEdit && (
        <StyleQuestionContainer
          setshowStyleEdit={setshowStyleEdit}
          stateObject={configQuestionStyle}
          setstateObject={setconfigQuestionStyle}
        ></StyleQuestionContainer>
      )}
      {openMessageYesNoModal && (
        <MessageYesNo
          setOpenMessageYesNoModal={setOpenMessageYesNoModal}
          message="Are you sure you want to delete this question?"
          setResponse={setResponse}
        ></MessageYesNo>
      )}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={selectCategory}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </GeneralStyle>
  );
};

export default SmileyFacesBox;
